import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { RideTypeService } from 'src/app/services/ride-type.service';

@Component({
    imports: [AngularSvgIconModule, FormsModule, MatButtonToggleModule],
    selector: 'rdx-snow-orv-toggle',
    styleUrls: ['./snow-orv-toggle.component.scss'],
    templateUrl: './snow-orv-toggle.component.html',
})
export class SnowOrvToggleComponent {
    @Input() rideType: 'snow' | 'orv';
    @Input() showIcon = false;
    @Input() showTitle = false;
    @Output() toggleClicked = new EventEmitter<void>();

    constructor(private rideTypeService: RideTypeService) {}

    setMapTypeSnow() {
        this.toggleClicked.emit();
        this.rideTypeService.setRideType('SNO');
    }

    setMapTypeOrv() {
        this.toggleClicked.emit();
        this.rideTypeService.setRideType('ORV');
    }
}
